import { render, staticRenderFns } from "./PrimaryLink.vue?vue&type=template&id=d4b510f2&"
import script from "./PrimaryLink.vue?vue&type=script&lang=ts&"
export * from "./PrimaryLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports